<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="!pageLoading">
      <v-row class="mb-1">
        <v-col cols="12">
          <filter-hoover-stats
            :default-search-params="searchParams"
            :is-component-loading="isRequestingNow"
            @filtering="onFilter"
            :has-report="false"
          ></filter-hoover-stats>
        </v-col>
      </v-row>


      <div v-if="data" class="mb-4">
        <h2>{{ $t('dashboard.promocodes_stats.base') }}</h2>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="3"
            v-for="month in Object.keys(data)"
            :key="month"
          >
            <v-card>
              <v-card-title>{{ formatMonth(month) }}</v-card-title>
              <v-divider />
              <v-simple-table dense class="font-weight-light">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left day-header">{{ $t('table.headers.day') }}</th>
                      <th class="text-left">{{ $t('table.headers.promocodes') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="day in Object.keys(data[month])" :key="day">
                      <td>{{ day }}</td>
                      <td>{{ data[month][day].slice(0, -2) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="dataComplex" class="mb-4">
        <v-divider width="100%" class="mt-8 mb-4" />
        <h2>{{ $t('dashboard.promocodes_stats.general') }}</h2>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="3"
            v-for="month in Object.keys(dataComplex)"
            :key="month"
          >
            <v-card>
              <v-card-title>{{ formatMonth(month) }}</v-card-title>
              <v-divider />
              <v-simple-table dense class="font-weight-light">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left day-header">{{ $t('table.headers.day') }}</th>
                      <th class="text-left">{{ $t('table.headers.promocodes') }} ({{ $t('table.headers.quantity')}})</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="day in Object.keys(dataComplex[month])" :key="day">
                      <td>{{ day }}</td>
                      <td>{{ dataComplex[month][day] }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
    <modal-loading :is-show="isTableLoading"></modal-loading>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
// import downloadReport from '@/mixins/reports/downloadReport';
import StatsProxy from '@/proxies/Stats/StatsOrdersProxy';
import { MANAGER_TOP } from '../../constants/roles';
/* mixins */
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';

/* components */
import ModalLoading from '../../components/loaders/ModalLoading.vue';
import FilterHooverStats from '../../components/listings/FilterHooverStats.vue';

export default {
  name: 'PromocodeStats',
  mixins: [updatePageContentMixin, defaultListingMixin],
  components: {
    ModalLoading,
    FilterHooverStats
  },
  data() {
    return {
      MANAGER_TOP,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        from: null,
        to: null,
        region: null,
        period: null
      },
      // reportMethodName: 'ordersCreatedListingReport',
      data: null,
      dataComplex: null
    };
  },
  computed: {
    /* store */
    account() {
      return this.$store.getters['account/account'];
    }
  },
  methods: {
    fetchData() {
      new StatsProxy('', this.searchParams)
        .byPromocode()
        .then(({ data: { data } }) => {
          this.data = data.base;
          this.dataComplex = data.complex;
        })
        .catch(error => {
          this.data = null;
          console.error(error);
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    computedValue(a, b) {
      if (a === 0) {
        return 0;
      }
      return (a / b) * 100;
    },
    formatMonth(month) {
      moment.locale(window.localStorage.language);
      const date = moment(month);
      return date.format('MMMM, YYYY');
    }
  }
};
</script>

<style scoped lang="scss">
.day-header {
  width: 60px;
}
</style>
